<template>
  <div>
    <ScreenAdapter>
      <div id="main">
        <Header :width="`1400`" />
        <Nav :width="`1400`" :height="`64`" />
        <!-- banner：党建思政教育资源平台（网上党校） -->
        <div class="platform-cover" :style="`background:url(${banner}) no-repeat top center/cover`"></div>
        <div class="eol-main-container marginTop">
          <!-- banner 下方 3 个跳转链接 -->
          <div class="entry-links anim-block">
            <!-- TODO: 跳转地址待用户提供 -->
            <div class="entry-item" v-for="item, index in entryLinks" :key="index" @click="jumpEntry(item)">
              <div class="entry-name" :style="`background-image: url(${item.cover});`"></div>
            </div>
          </div>

          <!-- 职业教育（原职业素养，category_id=136） -->
          <div class="rdbb-con anim-block" v-if="professionData && professionData.length > 0">
            <div class="content-header">
              <div class="categroy-title">职业教育</div>
              <div class="header-other">
                <div class="more" @click="jumpList('profession')">更多</div>
              </div>
            </div>
            <div class="rdbb-info">
              <div class="info-lfet" @click="jumpDetail(professionData[swiperActive], 'profession')">
                <div class="swiper">
                  <swiper :options="swiperOption" v-if="professionData.length > 0" ref="proSwiper">
                    <swiper-slide v-for="item in professionData" :key="item.id" :data-id="item.id">
                      <div class="cover" :style="`background-image: url(${item.photo});`" :data-id="item.id"></div>
                    </swiper-slide>
                  </swiper>
                  <!-- 页码：右上角短横 -->
                  <div class="rdbb-page">
                    <div class="page-item" @click="slideChange(i)" v-for="i in professionData.length" :key="i"
                      :class="{ active: swiperActive == i - 1 }"></div>
                  </div>
                </div>
              </div>
              <div class="info-right">
                <div class="info-link" @click="jumpDetail(professionData[swiperActive], 'profession')">
                  <div class="info-title">{{ professionData[swiperActive]?.name }}</div>
                  <div class="info-desc">{{ professionData[swiperActive]?.intro }}</div>
                </div>
                <!-- 橙色方块左右切换箭头 -->
                <div class="info-arrows">
                  <div class="arrow b swiper-button-prev"></div>
                  <div class="arrow b swiper-button-next"></div>
                </div>
              </div>
            </div>
            <!-- 底部 tab：4 条课程标语，选中红底带尖角 -->
            <div class="rdbb-tabs">
              <div class="tab-item" :class="{ active: swiperActive == index }" v-for="(item, index) in professionData"
                :key="item.id" @mouseenter="slideChange(index + 1)">
                <div class="tab-text">{{ item.name }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="outer-main-box dxxy">
          <div class="eol-main-container">
            <!-- 党性修养（category_id=106） -->
            <div class="card-con anim-block" v-if="cultureData && cultureData.length > 0">
              <div class="content-header">
                <div class="categroy-title">党性修养</div>
                <div class="header-other" v-if="cultureCat && cultureCat.length > 0">
                  <div class="more" @click="jumpList('culture')">更多</div>
                </div>
              </div>
              <div class="culture-box">
                <!-- 左侧 2 个 -->
                <div class="side-col">
                  <div class="side-cover" @click="jumpDetail(cultureData[0], 'culture')">
                    <div class="cover-img"
                      :style="`background:url(${cultureData[0] && cultureData[0].photo}) no-repeat center/cover;`">
                    </div>
                  </div>
                  <div class="side-cover" @click="jumpDetail(cultureData[1], 'culture')">
                    <div class="cover-img"
                      :style="`background:url(${cultureData[1] && cultureData[1].photo}) no-repeat center/cover;`">
                    </div>
                  </div>
                </div>
                <!-- 中间大图 -->
                <div class="big-cover" @click="jumpDetail(cultureData[2], 'culture')">
                  <div class="cover-img"
                    :style="`background:url(${cultureData[2] && cultureData[2].photo}) no-repeat center/cover;`"></div>
                </div>
                <!-- 右侧 2 个 -->
                <div class="side-col">
                  <div class="side-cover" @click="jumpDetail(cultureData[3], 'culture')">
                    <div class="cover-img"
                      :style="`background:url(${cultureData[3] && cultureData[3].photo}) no-repeat center/cover;`">
                    </div>
                  </div>
                  <div class="side-cover" @click="jumpDetail(cultureData[4], 'culture')">
                    <div class="cover-img"
                      :style="`background:url(${cultureData[4] && cultureData[4].photo}) no-repeat center/cover;`">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="outer-main-box">
          <div class="eol-main-container">
            <div class="main-second-box">
              <!-- 价值引领（category_id=110） -->
              <div class="grid-con value-con anim-block" v-if="valueCat && valueCat.length > 0">
                <div class="content-header">
                  <div class="categroy-title">价值引领</div>
                  <div class="header-other">
                    <!-- <div class="sub-content">
                      <div class="sub-item" v-for="item, index in valueCat" :key="index"
                        @click="jumpList('value', item)">{{
                          item.name }}</div>
                    </div> -->
                    <div class="more" @click="jumpList('value')">更多</div>
                  </div>
                </div>
                <div class="grid-box">
                  <div class="grid-item" v-for="item, index in valueCat" :key="index" @click="jumpList('value', item)">
                    <img class="grid-img" :src="require('../../assets/hzvtc/index-new/jzyl' + index + '.png')" />
                  </div>
                </div>
              </div>

              <!-- 家国情怀（category_id=121） -->
              <div class="grid-con feelings-con anim-block" v-if="feelingsCat && feelingsCat.length > 0">
                <div class="content-header">
                  <div class="categroy-title">家国情怀</div>
                  <div class="header-other" v-if="feelingsCat && feelingsCat.length > 0">
                    <!-- <div class="sub-content">
                      <div class="sub-item" v-for="item, index in feelingsCat" :key="index"
                        @click="jumpList('feelings', item)">{{ item.name }}</div>
                    </div> -->
                    <div class="more" @click="jumpList('feelings')">更多</div>
                  </div>
                </div>
                <div class="grid-box">
                  <div class="grid-item" v-for="item, index in feelingsCat" :key="index"
                    @click="jumpList('feelings', item)">
                    <img class="grid-img" :src="require('../../assets/hzvtc/index-new/jgqh' + index + '.png')" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>



        <div class="outer-main-box tswh">
          <div class="eol-main-container">
            <div class="double-content anim-block">
              <!-- 特色文化 -->
              <div class="content">
                <div class="content-header">
                  <div class="categroy-title">特色文化</div>
                  <div class="header-other">
                    <div class="more" @click="jumpList('feature')">更多</div>
                  </div>
                </div>
                <div class="content-box" v-if="featureData && featureData.length > 0">
                  <div class="sub-cover">
                    <div class="cover-item" @click="jumpDetail(item, 'feature')" v-for="item, index in featureData"
                      :key="index">
                      <div class="cover-img" :style="`background:url(${item.photo}) no-repeat center/cover;`"></div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 生命教育 -->
              <div class="content">
                <div class="content-header">
                  <div class="categroy-title">健康教育</div>
                  <div class="header-other">
                    <div class="more" @click="jumpList('vita')">更多</div>
                  </div>
                </div>
                <div class="content-box" v-if="vitaData && vitaData.length > 0">
                  <template v-for="item, index in vitaData">
                    <div class="big-cover" @click="jumpDetail(item, 'vita')" v-if="index == 0" :key="index">
                      <div class="cover-img" :style="`background:url(${item.photo}) no-repeat center/cover;`"></div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 专业群思政（两个分类 Tab 切换 + 整屏宽度轮播） -->
        <div class="zsi-con anim-block">
          <div class="eol-main-container">
            <div class="content-header">
              <div class="categroy-title">专业群思政</div>
              <div class="header-other">
                <div class="zsi-tabs">
                  <div class="zsi-tab" :class="{ active: zsiActiveTab == index }" v-for="(tab, index) in zsiTabs"
                    :key="index" @click="switchZsiTab(index)">{{ tab.name }}</div>
                </div>
                <div class="more" @click="jumpZyqsz()">更多</div>
              </div>
            </div>
          </div>
          <!-- 整屏轮播：Tab 切换分类。用 v-if 只渲染当前 tab 的轮播，
               保证目标轮播始终在「可见」状态下初始化，autoplay 才能正常启动 -->
          <div v-if="zsiActiveTab == 0" class="zsi-carousel">
            <swiper :options="zsiSwiperOption" key="0" ref="zsiSwiper1" v-if="yxxyData.length > 0">
              <swiper-slide v-for="item in yxxyData" :key="item.id">
                <div class="zsi-slide" @click="jumpArticle(item)">
                  <div class="zsi-cover">
                    <div class="cover-img" :style="`background:url(${item.cover_url}) no-repeat center/cover;`"></div>
                  </div>
                  <div class="zsi-info">
                    <div class="zsi-name">{{ item.title }}</div>
                  </div>
                </div>
              </swiper-slide>
            </swiper>
            <!-- <div class="b zsi-prev"></div>
            <div class="b zsi-next"></div> -->
          </div>

          <div v-if="zsiActiveTab == 1"  class="zsi-carousel">
            <swiper :options="zsiSwiperOption" key="1" ref="zsiSwiper2" v-if="szzyData.length > 0">
              <swiper-slide v-for="item in szzyData" :key="item.id">
                <div class="zsi-slide" @click="jumpArticle(item)">
                  <div class="zsi-cover">
                    <div class="cover-img" :style="`background:url(${item.cover_url}) no-repeat center/cover;`"></div>
                  </div>
                  <div class="zsi-info">
                    <div class="zsi-name">{{ item.title }}</div>
                  </div>
                </div>
              </swiper-slide>
            </swiper>
            <!-- <div class="b zsi-prev"></div>
            <div class="b zsi-next"></div> -->
          </div>
        </div>

        <Foohter />
      </div>
    </ScreenAdapter>

  </div>
</template>

<script>
import Header from "@/components/Hzvtc/Header.vue"
import Nav from "@/components/Hzvtc/Nav.vue"
import Foohter from "@/components/Hzvtc/Footer.vue"
import ScreenAdapter from "@/components/ScreenAdapter.vue"
import services from '../../config/services'
import $ from 'jquery'
import "../../assets/js/jquery.hoverdir.js"
export default {
  data() {
    let that = this
    // 专业群思政分类 category_id 区分环境：生产 优秀校友-721、思政资源-722；测试/开发 优秀校友-686、思政资源-687
    const isPro = process.env.NODE_ENV == 'production' && process.env.VUE_APP_FLAG === 'pro'
    const alumniId = isPro ? '721' : '686'
    const szzyId = isPro ? '722' : '687'
    const siteId = isPro ? 7 : 3
    return {
      banner: require("../../assets/hzvtc/index-new/index-banner.jpg"),
      school_code: services.HZ_CODE,
      swiperActive: 0,
      swiperOption: {
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next.b",
          prevEl: ".swiper-button-prev.b",
        },
        on: {
          slideChangeTransitionEnd() {
            that.swiperActive = this.realIndex
          },
          hover() {
            const slide = this.clickedSlide
            if (!slide) return
            const id = slide.getAttribute("data-id")
            window.open(`/center/${that.school_code}/hzvtc/detail?id=${id}&key=profession`, "_blank")
          }
        }
      },
      zsiSwiperOption: {
        loop: true,
        slidesPerView: 5,
        spaceBetween: 40,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        // navigation: {
        //   nextEl: ".zsi-next.b",
        //   prevEl: ".zsi-prev.b",
        // },
      },
      zsiActiveTab: 0,
      siteId,
      alumniId,
      szzyId,
      // 专业群思政两个分类 Tab
      zsiTabs: [
        { name: "优秀校友", category_id: alumniId },
        { name: "思政资源", category_id: szzyId },
      ],
      // banner 下方 3 个跳转链接
      entryLinks: [
        { name: "杭职党校", cover: require("../../assets/hzvtc/index-new/entry1.jpg"), url: `${window.location.origin}/center/${services.HZ_CODE}/hzvtc/hzdx` },
        { name: "树立和践行正确政绩观", cover: require("../../assets/hzvtc/index-new/entry2.jpg"), url: 'https://cpc.people.com.cn/GB/67481/461783/index.html' },
        { name: "深入贯彻中央八项规定精神学习教育", cover: require("../../assets/hzvtc/index-new/entry3.jpg"), url: 'https://www.12371.cn/bxgd/' },
      ],
      cultureData: [], // 党性修养数据
      valueData: [], // 价值引领数据
      feelingsData: [], // 家国情怀数据
      professionData: [], // 职业教育（原职业素养）
      featureData: [], // 特色文化数据
      vitaData: [], // 健康教育（原生命教育）数据
      yxxyData: [], // 专业群思政 - 优秀校友
      szzyData: [], // 专业群思政 - 思政资源
      // 二级分类数据
      cultureCat: [], // 党性修养二级分类
      valueCat: [], // 价值引领二级分类
      feelingsCat: [], // 家国情怀二级分类
      professionCat: [], // 职业教育二级分类
    }
  },
  components: {
    Header,
    Nav,
    Foohter,
    ScreenAdapter
  },
  mounted() {
    this.getCatData()
    this.getListData()
  },
  methods: {
    // 取分类名最后一级
    lastCat(name) {
      if (!name) return ''
      const arr = name.split("-")
      return arr[arr.length - 1]
    },
    decodeHtml(html) {
      if (!html) return ''
      const doc = new DOMParser().parseFromString(html, 'text/html')
      return doc.documentElement.textContent
    },
    // 从富文本中提取纯文本（去掉 HTML 标签，并处理转义实体）
    stripHtml(html) {
      if (!html) return ''
      // 先解码可能存在的实体转义，再解析一次提取纯文本
      const decoded = this.decodeHtml(html)
      const doc = new DOMParser().parseFromString(decoded, 'text/html')
      return (doc.body.textContent || '').replace(/\s\s+/g, ' ').trim()
    },
    // 进场动画
    setHoverAndAnim() {
      this.$nextTick(() => {
        this.checkInView()
        $(".outContainer").off("scroll.indexAnim").on("scroll.indexAnim", () => {
          this.checkInView()
        })
      })
    },
    checkInView() {
      // ScreenAdapter 用 transform:scale 缩放，需用 getBoundingClientRect 的真实视觉坐标判断
      $(".anim-block").each(function () {
        const top = this.getBoundingClientRect().top
        if (top < window.innerHeight - 100) {
          $(this).addClass("fade-in")
        }
      })
    },
    // 职业教育轮播缩略图/页码联动
    slideChange(index) {
      this.swiperActive = index - 1
      if (this.$refs.proSwiper) {
        this.$refs.proSwiper.swiper.slideToLoop(index - 1)
      }
    },
    // 专业群思政 Tab 切换：数据已在初始化时请求，用 v-if 切换渲染对应轮播，
    // 目标轮播在可见状态下全新初始化，loop 与 autoplay 自然生效，无需手动处理
    switchZsiTab(index) {
      if (this.zsiActiveTab === index) return
      this.zsiActiveTab = index
    },
    // banner 3 链接跳转（地址待补充）
    jumpEntry(item) {
      if (item.url) window.open(item.url, "_blank")
    },
    // 跳转到课程详情
    jumpDetail(item, key) {
      if (!item) return
      window.open(`/center/${this.school_code}/hzvtc/detail?id=${item.id}&key=${key}`, "_blank")
    },
    // 跳转到文章详情
    jumpArticle(item) {
      if (!item) return
      if(item.type == 3 && item.url){
        window.open(item.url, "_blank",);
      } else {
        window.open(`/center/${this.school_code}/hzvtc/article?id=${item.id}&key=zyqsz`, "_blank")
      }
    },
    // 专业群思政-更多跳转
    jumpZyqsz(){
      window.open(`/center/${this.school_code}/hzvtc/zyqsz?id=${this.zsiTabs[this.zsiActiveTab].category_id}`, "_blank")
    },
    // 跳转到课程列表：点击更多跳转到列表，点击二级分类跳转列表锚点定位到指定分类下
    jumpList(key, info) {
      if((key == 'value' && info.id == 113)){
        window.open(`/center/${this.school_code}/hzvtc/detail?id=341&key=${key} `, "_blank")
      } else if((key == 'feelings' && info.id == 193)){
        window.open(`/center/${this.school_code}/hzvtc/detail?id=340&key=${key} `, "_blank")
      } else {
        window.open(`/center/${this.school_code}/hzvtc/${key}${info ? ('?id=' + info.id) : ''}`, "_blank")
      }
    },
    async getListData() {
      // 8 个接口并行请求，互不阻塞，加快页面加载
      await Promise.all([
        // 职业教育（原职业素养）：轮播+课程信息，取带简介的课程
        services.getCourseList({ page: 1, size: 4, category_id: "136", is_intro: "1", school_code: this.school_code }).then(res => {
          res.data && res.data.items.length > 0 && res.data.items.forEach(elem => {
           elem.intro = this.stripHtml(elem.intro);
          });
          this.professionData = res.data.items
          
        }),
        // 党性修养
        services.getCourseList({ page: 1, size: 5, category_id: "106", school_code: this.school_code }).then(res => {
          this.cultureData = res.data.items
        }),
        // 价值引领
        services.getCourseList({ page: 1, size: 3, category_id: "110", school_code: this.school_code }).then(res => {
          this.valueData = res.data.items
        }),
        // 家国情怀
        services.getCourseList({ page: 1, size: 2, category_id: "121", school_code: this.school_code }).then(res => {
          this.feelingsData = res.data.items
        }),
        // 特色文化
        services.getCourseList({ page: 1, size: 4, category_id: "195", school_code: this.school_code }).then(res => {
          this.featureData = res.data.items
        }),
        // 健康教育（原生命教育）
        services.getCourseList({ page: 1, size: 1, category_id: "152", school_code: this.school_code }).then(res => {
          this.vitaData = res.data.items
        }),
        // 专业群思政 - 优秀校友
        services.getRmtNewsList({ page: 1, length: 10,site_id: this.siteId, category_id: this.alumniId, order_by: 'weight desc,publish_time desc'}).then(res => {
          this.yxxyData = res.data.items
        }),
        // 专业群思政 - 思政资源
        services.getRmtNewsList({ page: 1, length: 10,site_id: this.siteId, category_id: this.szzyId, order_by: 'weight desc,publish_time desc' }).then(res => {
          this.szzyData = res.data.items
        }),
      ])
      // 数据就绪后绑定动画与 hover
      this.setHoverAndAnim()
    },
    async getCatData() {
      // 4 个二级分类接口并行请求
      await Promise.all([
        // 职业教育二级分类
        services.getCategoryList({ root_id: "136", school_code: this.school_code }).then(res => {
          this.professionCat = res.data
        }),
        // 党性修养二级分类
        services.getCategoryList({ root_id: "106", school_code: this.school_code }).then(res => {
          this.cultureCat = res.data
        }),
        // 价值引领二级分类
        services.getCategoryList({ root_id: "110", school_code: this.school_code }).then(res => {
          this.valueCat = res.data
        }),
        // 家国情怀二级分类
        services.getCategoryList({ root_id: "121", school_code: this.school_code }).then(res => {
          this.feelingsCat = res.data
        }),
      ])
    },
  },
}
</script>

<style lang="less" scoped>
#main {
  background: #fff;
}

.platform-cover {
  width: 100%;
  height: 880px;
}

.outer-main-box {
  width: 100%;
  background: url("../../assets/hzvtc/index-new/outerbg2.jpg") no-repeat center/cover;
  padding-top: 60px;

  &.dxxy {
    min-height: 562px;
    margin-top: -60px;
    background: url("../../assets/hzvtc/index-new/outerbg1.jpg") no-repeat center/cover;
  }

  &.tswh {
    padding-top: 30px;
    background-image: url("../../assets/hzvtc/index-new/outerbg3.jpg");
    background-repeat: no-repeat;
    background-size: 100% 415px;
    background-position: top;
  }

}

.main-second-box {
  display: flex;
  justify-content: space-between;
}

.eol-main-container {
  width: 1400px;
  margin: 0 auto;

  &.marginTop {
    margin-top: -352px;
  }

  // 通用栏目标题
  .content-header {
    display: flex;
    align-items: flex-end;
    margin-bottom: 40px;

    .categroy-title {
      font-weight: bold;
      font-size: 42px;
      color: #b61e2a;
      background: linear-gradient(0deg, #b61e2a 0%, #ef350a 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      line-height: 1;
    }

    .header-other {
      display: flex;
      align-items: flex-end;

      .sub-content {
        display: flex;
        align-items: center;

        .sub-item {
          padding: 0 16px;
          font-size: 15px;
          font-weight: bold;
          color: #ffffff;
          height: 32px;
          background: #d57048;
          border-radius: 4px;
          line-height: 32px;
          cursor: pointer;

          &:not(:last-child) {
            margin-right: 8px;
          }
        }
      }

      .more {
        margin-left: 24px;
        font-size: 15px;
        color: #B61E2A;
        cursor: pointer;
        display: flex;
        align-items: center;

        &::after {
          content: '';
          display: inline-block;
          width: 12px;
          height: 13px;
          background: url('../../assets/hzvtc/index-new/more-default.jpg') no-repeat center/cover;
          margin-left: 5px;
        }

        &:hover::after {
          background: url('../../assets/hzvtc/index-new/more-hover.jpg') no-repeat center/cover;
        }
      }
    }
  }

  // banner 下方 3 个跳转链接
  .entry-links {
    display: flex;
    justify-content: space-between;
    margin: -60px 0 56px;
    position: relative;
    z-index: 10;

    .entry-item {
      width: 427px;
      height: 140px;
      transition: all 0.3s;
      cursor: pointer;

      &:hover {
        transform: translateY(-4px);
        // box-shadow: 0px 10px 24px 0px rgba(182, 30, 42, 0.2);
      }

      .entry-name {
        width: 100%;
        height: 100%;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        border-radius: 6px;
      }
    }
  }

  // 进场动画
  .anim-block {
    visibility: hidden;
    margin-bottom: 70px;

    &.fade-in {
      visibility: visible;
      animation-name: fadeInUp;
      animation-delay: 0s;
      -webkit-animation-duration: 0.8s;
      animation-duration: 0.8s;
      -webkit-animation-fill-mode: both;
      animation-fill-mode: both;
    }
  }

  // 职业教育（轮播 + 底部 tab，按设计图）
  .rdbb-con {
    .rdbb-info {
      height: 477px;
      display: flex;

      .info-lfet {
        width: 848px;
        height: 100%;
        position: relative;
        border: 3px solid #F6B888;

        .swiper {
          height: 100%;
          overflow: hidden;

          .swiper-container {
            height: 100%;

            .swiper-wrapper {
              .swiper-slide {
                background-color: #b61e2a;
                overflow: hidden;
                height: 100%;
                cursor: pointer;

                &:hover {
                  .cover {
                    transform: scale(1.1);
                  }
                }

                .cover {
                  width: 100%;
                  height: 100%;
                  background-size: cover;
                  background-position: center;
                  transition: all 0.3s;
                }
              }
            }
          }
        }

        // 页码：右上角短横
        .rdbb-page {
          position: absolute;
          bottom: 118px;
          right: -45px;
          transform: translate(100%, 0);
          display: flex;
          z-index: 11;

          .page-item {
            width: 40px;
            height: 4px;
            background: #CDD1D9;
            margin-right: 16px;
            cursor: pointer;
            transition: all 0.3s;

            &.active {
              background: #C9261F;
            }
          }
        }
      }

      .info-right {
        height: 100%;
        flex: 1;
        background: #F4F7FB;
        padding: 65px 50px 20px 45px;
        box-sizing: border-box;
        position: relative;
        &:hover {
           .info-title {
            color: #C9261F;
           }
        }

        .info-link {
          cursor: pointer;
        }

        .info-title {
          font-weight: bold;
          font-size: 20px;
          color: #333333;
          line-height: 34px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
        }

        .info-desc {
          font-size: 16px;
          color: #868686;
          line-height: 32px;
          text-align: left;
          height: 192px;
          margin-top: 30px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 6;
        }

        // 橙色方块左右箭头
        .info-arrows {
          position: absolute;
          left: -28px;
          bottom: 45px;
          display: flex;
          z-index: 10;

          .arrow {
            width: 48px;
            height: 40px;
            background: #DB7841;
            border-radius: 4px;
            cursor: pointer;
            display: flex;
            justify-content: center;
            align-items: center;
            transition: all 0.3s;

            &:not(:last-child) {
              margin-right: 18px;
            }

            &:hover {
              background: #C9261F;
            }

            &::after {
              width: 18px;
              height: 15px;
              content: '';
              display: block;
              background: url('../../assets/hzvtc/index-new/left.png') no-repeat center/contain;
            }

            &.swiper-button-next::after {
              transform: rotate(180deg);
            }
          }
        }
      }
    }

    // 底部 tab：4 条课程标语
    .rdbb-tabs {
      display: flex;
      justify-content: space-between;
      margin-top: 24px;

      .tab-item {
        flex: 1;
        height: 112px;
        background: url('../../assets/hzvtc/index-new/zyjy-default.png') no-repeat center/contain;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        position: relative;
        transition: all 0.3s;

        &:not(:last-child) {
          margin-right: 20px;
        }

        .tab-text {
          font-weight: bold;
          font-size: 17px;
          color: #C9261F;
          text-align: center;
          padding: 0 16px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          line-height: 22px;
        }

        &.active {
          background: linear-gradient(180deg, #c8202c 0%, #b61e2a 100%);

          .tab-text {
            color: #ffffff;
          }

          // 顶部向上尖角
          &::before {
            content: '';
            position: absolute;
            top: -9px;
            left: 50%;
            transform: translateX(-50%);
            width: 0;
            height: 0;
            border-left: 10px solid transparent;
            border-right: 10px solid transparent;
            border-bottom: 10px solid #c8202c;
          }
        }
      }
    }
  }

  // 党性修养（卡片组：左右各2 + 中间大）
  .card-con {
    .culture-box {
      display: flex;
      justify-content: space-between;
      height: 384px;

      // 左右两侧列：各 2 个上下排列
      .side-col {
        width: 335px;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .side-cover {
          width: 100%;
          height: 180px;
        }
      }

      .side-cover {
        position: relative;
        overflow: hidden;
        border-radius: 4px;
        cursor: pointer;

        .cover-img {
          width: 100%;
          height: 100%;
          transition: transform 0.3s;
        }

        &:hover .cover-img {
          transform: scale(1.1);
        }
      }

      .big-cover {
        width: 682px;
        height: 384px;
        position: relative;
        overflow: hidden;
        border-radius: 4px;
        cursor: pointer;

        .cover-img {
          width: 100%;
          height: 100%;
          transition: transform 0.3s;
        }

        &:hover .cover-img {
          transform: scale(1.1);
        }
      }

      .cover-title {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        padding: 0 20px;
        height: 48px;
        line-height: 48px;
        background: linear-gradient(0deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0) 100%);
        color: #fff;
        font-size: 16px;
        z-index: 2;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }

  // 价值引领 / 家国情怀
  .grid-con {
    .grid-item {
      overflow: hidden;
      cursor: pointer;
      border-radius: 4px;

      .grid-img {
        display: block;
        width: 100%;
        height: 100%;
        transition: transform 0.3s ease;
      }

      &:hover .grid-img {
        transform: scale(1.1);
      }
    }
  }

  // 价值引领（670×109，一列三行，纵向堆叠）
  .value-con {
    .grid-box {
      width: 670px;
      height: 368px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }

    .grid-item {
      width: 670px;
      height: 110px;
    }
  }

  // 家国情怀（320×368，两列一行，横向排列）
  .feelings-con {
    .grid-box {
      width: 670px;
      display: flex;
      justify-content: space-between;
    }

    .grid-item {
      width: 320px;
      height: 368px;
    }
  }

  .double-content {
    display: flex;
    justify-content: space-between;
    position: relative;
    z-index: 1001;

    .content-header {
      padding: 34px 0 18px;
    }

    .content {
      flex: 1;

      &:last-child {
        flex-shrink: 0;
        margin-left: 60px;
      }

      &:first-child {
        .content-header {
          padding-right: 20px;

          .name {
            &::after {
              background: url('../../assets/hzvtc/index/title-feature.png') no-repeat center/cover;
            }
          }
        }
      }

      .content-header {
        padding-right: 20px;

        .name {
          &::after {
            background: url('../../assets/hzvtc/index/title-vita.png') no-repeat center/cover;
          }
        }
      }

      .big-cover {
        width: 670px;
        height: 377px;
        cursor: pointer;
        overflow: hidden;
        border-radius: 4px;
        .cover-img {
          width: 100%;
          height: 100%;
          transition: transform 0.3s ease;
        }

        &:hover .cover-img {
          transform: scale(1.05);
        }
      }

      .sub-cover {
        display: flex;
        justify-content: space-between;
        align-content: space-between;
        flex-wrap: wrap;

        .cover-item {
          width: 325px;
          height: 183px;
          cursor: pointer;
          margin-bottom: 12px;
          overflow: hidden;
          border-radius: 4px;

          .cover-img {
            width: 100%;
            height: 100%;
            transition: transform 0.3s ease;
          }

          &:hover .cover-img {
            transform: scale(1.05);
          }
        }
      }
    }
  }


}

// 专业群思政（两个分类 Tab 切换 + 整屏宽度轮播）
.zsi-con {
  width: 100%;

  .content-header {
    padding: 10px 0 23px;

    .header-other {
      margin-left: 35px;
    }
  }

  // 进场动画（.zsi-con 在 .eol-main-container 外，需单独声明）
  &.anim-block {
    visibility: hidden;

    &.fade-in {
      visibility: visible;
      animation-name: fadeInUp;
      animation-delay: 0.1s;
      animation-duration: 0.8s;
      animation-fill-mode: both;
    }
  }

  // Tab 切换（顶部带尖角的红色选中态）
  .header-other .zsi-tabs {
    display: flex;
    align-items: flex-end;
    transform: translateY(6px); 

    .zsi-tab {
      width: 166px;
      height: 58px;
      line-height: 58px;
      text-align: center;
      font-weight: bold;
      font-size: 24px;
      color: #DD2919;
      background: #FFFFFF;
      border-radius: 10px 10px 0px 0px;
      border: 1px solid #DD2919;
      cursor: pointer;
      position: relative;

      &:not(:last-child) {
        margin-right: 23px;
      }

      &.active {
        color: #ffffff;
        background: #DD2919;

        &::after {
          content: '';
          position: absolute;
          left: 50%;
          bottom: -8px;
          transform: translateX(-50%);
          width: 0;
          height: 0;
          border-left: 8px solid transparent;
          border-right: 8px solid transparent;
          border-top: 8px solid #DD2919;
        }
      }
    }
  }

  .zsi-carousel {
    position: relative;
    width: 100%;
    overflow: hidden;
    padding-bottom: 55px;
    background: linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 46%, #FFF5E3 100%);

    .zsi-slide {
      position: relative;
      cursor: pointer;

      .zsi-cover {
        width: 100%;
        aspect-ratio: 16 / 9;
        overflow: hidden;
        border-radius: 4px;

        .cover-img {
          width: 100%;
          height: 100%;
          aspect-ratio: 16 / 9;
          transition: transform 0.3s ease;
        }

        &:hover .cover-img {
          transform: scale(1.1);
        }
      }

      .zsi-info {
        width: 100%;
        height: 85px;
        padding-top: 25px;

        .zsi-name {
          font-weight: bold;
          font-size: 17px;
          color: #2A2B2C;
          line-height: 30px;
          height: 60px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
        }
      }
    }

    // 左右翻页箭头
    .b.zsi-prev,
    .b.zsi-next {
      width: 56px;
      height: 56px;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.9);
      box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.15);
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      z-index: 11;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.3s;

      &:hover {
        background: #ffffff;
      }

      &::after {
        content: '';
        display: block;
        width: 19px;
        height: 15px;
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
      }
    }

    .b.zsi-prev {
      left: 320px;

      &::after {
        background-image: url('../../assets/hzvtc/index-new/left.png');
      }
    }

    .b.zsi-next {
      right: 320px;

      &::after {
        background-image: url('../../assets/hzvtc/index-new/right.png');
      }
    }
  }
}

@keyframes fadeInUp {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, 60px, 0);
    transform: translate3d(0, 60px, 0);
  }

  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}
</style>
